@if (card.data) {
  @if (!card?.context?.use_new_ui) {
    <app-feed-subject-carousel [feed_subject]="card.data" [title]="card.title"></app-feed-subject-carousel>
  } @else {
    <app-new-ui-layout [card]="card" [timeline_id]="timeline_id"></app-new-ui-layout>
  }
}
